import { OnChangeParams } from 'baseui/select';
import { FLEET_ASSET_TYPE_OPTIONS } from '../../../constants/fleetAssets';
import { AssetType } from '../../../types/asset';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

type Props = {
  onTypesChange: (ids: AssetType[]) => void;
  inline?: boolean;
  required?: boolean;
  assetTypes: AssetType[];
  error?: React.ReactNode;
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
};

export function MultipleFleetAssetTypeSelect({
  onTypesChange,
  assetTypes,
  inline = false,
  required = false,
  error,
  onBlur,
  label = 'Tipo de activo:',
  placeholder,
}: Readonly<Props>) {
  const onChange = (params: OnChangeParams) => {
    const optionId = params.option?.id;
    if (!optionId) return;
    if (params.type === 'select') {
      onTypesChange([...assetTypes, optionId as AssetType]);
    } else if (params.type === 'remove') {
      onTypesChange(assetTypes.filter((assetType) => assetType !== optionId));
    } else {
      onTypesChange([]);
    }
  };

  if (inline) {
    return (
      <EnhancedLabeledSelect
        label={label}
        onChange={onChange}
        options={FLEET_ASSET_TYPE_OPTIONS}
        value={assetTypes !== undefined ? assetTypes?.map((assetType) => ({ id: assetType })) : undefined}
        placeholder={placeholder}
        inset
        inline
        isMulti
      />
    );
  }

  return (
    <EnhancedLabeledSelect
      label={label}
      placeholder={placeholder}
      required={required}
      options={FLEET_ASSET_TYPE_OPTIONS}
      onChange={onChange}
      value={assetTypes !== undefined ? assetTypes?.map((assetType) => ({ id: assetType })) : undefined}
      error={error}
      onBlur={onBlur}
      isMulti
    />
  );
}
